// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/user.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Date } from "../google/type/date_pb";
import { file_google_type_date } from "../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/user.proto.
 */
export const file_v1_user: GenFile = /*@__PURE__*/
  fileDesc("Cg12MS91c2VyLnByb3RvEgJ2MSJXCgxMb2dpblJlcXVlc3QSEAoIdXNlcm5hbWUYASABKAkSEAoIcGFzc3dvcmQYAiABKAkSIwoLY2xpZW50X2luZm8YAyABKAsyDi52MS5DbGllbnRJbmZvIuYBCg1Mb2dpblJlc3BvbnNlEhQKDGFjY2Vzc190b2tlbhgBIAEoCRIVCg1yZWZyZXNoX3Rva2VuGAIgASgJEhgKEGNhbGN1bGF0aW9uX3R5cGUYAyABKAkSKgoPcHVyY2hhc2VfZXhwaXJ5GAQgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZRIQCgh1c2VybmFtZRgFIAEoCRIMCgRyb2xlGAYgASgJEh8KF3RlbGVncmFtX2N1c3RvbWVyX2xpbWl0GAggASgFEhAKCGZlYXR1cmVzGAkgAygJSgQIBxAIUgliZXRhX3Rlc3QiUQoTUmVmcmVzaFRva2VuUmVxdWVzdBIVCg1yZWZyZXNoX3Rva2VuGAEgASgJEiMKC2NsaWVudF9pbmZvGAIgASgLMg4udjEuQ2xpZW50SW5mbyLCAQoKQ2xpZW50SW5mbxIRCglkZXZpY2VfaWQYASABKAkSFAoMYnJvd3Nlcl9uYW1lGAIgASgJEhcKD2Jyb3dzZXJfdmVyc2lvbhgDIAEoCRIPCgdvc19uYW1lGAQgASgJEhIKCm9zX3ZlcnNpb24YBSABKAkSEwoLZGV2aWNlX3R5cGUYBiABKAkSFAoMZGV2aWNlX21vZGVsGAcgASgJEg4KBnNjcmVlbhgIIAEoCRISCgp1c2VyX2FnZW50GAkgASgJIg8KDUxvZ291dFJlcXVlc3QiMgoOTG9nb3V0UmVzcG9uc2USDwoHc3VjY2VzcxgBIAEoCBIPCgdtZXNzYWdlGAIgASgJIkcKFUNoYW5nZVBhc3N3b3JkUmVxdWVzdBIYChBjdXJyZW50X3Bhc3N3b3JkGAEgASgJEhQKDG5ld19wYXNzd29yZBgCIAEoCSI6ChZDaGFuZ2VQYXNzd29yZFJlc3BvbnNlEg8KB3N1Y2Nlc3MYASABKAgSDwoHbWVzc2FnZRgCIAEoCTL5AQoLVXNlclNlcnZpY2USLgoFTG9naW4SEC52MS5Mb2dpblJlcXVlc3QaES52MS5Mb2dpblJlc3BvbnNlIgASPAoMUmVmcmVzaFRva2VuEhcudjEuUmVmcmVzaFRva2VuUmVxdWVzdBoRLnYxLkxvZ2luUmVzcG9uc2UiABIxCgZMb2dvdXQSES52MS5Mb2dvdXRSZXF1ZXN0GhIudjEuTG9nb3V0UmVzcG9uc2UiABJJCg5DaGFuZ2VQYXNzd29yZBIZLnYxLkNoYW5nZVBhc3N3b3JkUmVxdWVzdBoaLnYxLkNoYW5nZVBhc3N3b3JkUmVzcG9uc2UiAEIoWiZnaXRodWIuY29tL2R1Y2J0L3R0LWdvL2dlbi9wcm90by92MTt2MWIGcHJvdG8z", [file_google_type_date]);

/**
 * @generated from message v1.LoginRequest
 */
export type LoginRequest = Message<"v1.LoginRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * Optional. Omitted by clients built before device tracking existed.
   *
   * @generated from field: v1.ClientInfo client_info = 3;
   */
  clientInfo?: ClientInfo;
};

/**
 * Describes the message v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> = /*@__PURE__*/
  messageDesc(file_v1_user, 0);

/**
 * @generated from message v1.LoginResponse
 */
export type LoginResponse = Message<"v1.LoginResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;

  /**
   * @generated from field: string calculation_type = 3;
   */
  calculationType: string;

  /**
   * @generated from field: google.type.Date purchase_expiry = 4;
   */
  purchaseExpiry?: Date;

  /**
   * @generated from field: string username = 5;
   */
  username: string;

  /**
   * @generated from field: string role = 6;
   */
  role: string;

  /**
   * @generated from field: int32 telegram_customer_limit = 8;
   */
  telegramCustomerLimit: number;

  /**
   * Beta features granted to this user, e.g. "bet_limit". Admins see every
   * feature regardless of this list.
   *
   * @generated from field: repeated string features = 9;
   */
  features: string[];
};

/**
 * Describes the message v1.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> = /*@__PURE__*/
  messageDesc(file_v1_user, 1);

/**
 * @generated from message v1.RefreshTokenRequest
 */
export type RefreshTokenRequest = Message<"v1.RefreshTokenRequest"> & {
  /**
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;

  /**
   * Optional. Omitted by clients built before device tracking existed.
   *
   * @generated from field: v1.ClientInfo client_info = 2;
   */
  clientInfo?: ClientInfo;
};

/**
 * Describes the message v1.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema: GenMessage<RefreshTokenRequest> = /*@__PURE__*/
  messageDesc(file_v1_user, 2);

/**
 * ClientInfo describes the browser a request comes from. The frontend fills
 * it from User-Agent Client Hints where available and the UA string otherwise.
 *
 * @generated from message v1.ClientInfo
 */
export type ClientInfo = Message<"v1.ClientInfo"> & {
  /**
   * Random UUID kept in the browser's localStorage. Identifies one browser
   * install, so two identical phones are two devices.
   *
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * @generated from field: string browser_name = 2;
   */
  browserName: string;

  /**
   * @generated from field: string browser_version = 3;
   */
  browserVersion: string;

  /**
   * @generated from field: string os_name = 4;
   */
  osName: string;

  /**
   * @generated from field: string os_version = 5;
   */
  osVersion: string;

  /**
   * mobile | tablet | desktop (or another ua-parser device type).
   *
   * @generated from field: string device_type = 6;
   */
  deviceType: string;

  /**
   * Empty when the browser does not expose it.
   *
   * @generated from field: string device_model = 7;
   */
  deviceModel: string;

  /**
   * "<width>x<height>@<devicePixelRatio>", e.g. "390x844@3".
   *
   * @generated from field: string screen = 8;
   */
  screen: string;

  /**
   * @generated from field: string user_agent = 9;
   */
  userAgent: string;
};

/**
 * Describes the message v1.ClientInfo.
 * Use `create(ClientInfoSchema)` to create a new message.
 */
export const ClientInfoSchema: GenMessage<ClientInfo> = /*@__PURE__*/
  messageDesc(file_v1_user, 3);

/**
 * Username is extracted from JWT context, not from request
 *
 * @generated from message v1.LogoutRequest
 */
export type LogoutRequest = Message<"v1.LogoutRequest"> & {
};

/**
 * Describes the message v1.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_v1_user, 4);

/**
 * @generated from message v1.LogoutResponse
 */
export type LogoutResponse = Message<"v1.LogoutResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message v1.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> = /*@__PURE__*/
  messageDesc(file_v1_user, 5);

/**
 * @generated from message v1.ChangePasswordRequest
 */
export type ChangePasswordRequest = Message<"v1.ChangePasswordRequest"> & {
  /**
   * @generated from field: string current_password = 1;
   */
  currentPassword: string;

  /**
   * @generated from field: string new_password = 2;
   */
  newPassword: string;
};

/**
 * Describes the message v1.ChangePasswordRequest.
 * Use `create(ChangePasswordRequestSchema)` to create a new message.
 */
export const ChangePasswordRequestSchema: GenMessage<ChangePasswordRequest> = /*@__PURE__*/
  messageDesc(file_v1_user, 6);

/**
 * @generated from message v1.ChangePasswordResponse
 */
export type ChangePasswordResponse = Message<"v1.ChangePasswordResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message v1.ChangePasswordResponse.
 * Use `create(ChangePasswordResponseSchema)` to create a new message.
 */
export const ChangePasswordResponseSchema: GenMessage<ChangePasswordResponse> = /*@__PURE__*/
  messageDesc(file_v1_user, 7);

/**
 * @generated from service v1.UserService
 */
export const UserService: GenService<{
  /**
   * @generated from rpc v1.UserService.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * @generated from rpc v1.UserService.RefreshToken
   */
  refreshToken: {
    methodKind: "unary";
    input: typeof RefreshTokenRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * @generated from rpc v1.UserService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
  /**
   * @generated from rpc v1.UserService.ChangePassword
   */
  changePassword: {
    methodKind: "unary";
    input: typeof ChangePasswordRequestSchema;
    output: typeof ChangePasswordResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_user, 0);

